"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankstatementsBalancesToJSON = exports.BankstatementsBalancesFromJSONTyped = exports.BankstatementsBalancesFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BankstatementsBalancesFromJSON(json) {
    return BankstatementsBalancesFromJSONTyped(json, false);
}
exports.BankstatementsBalancesFromJSON = BankstatementsBalancesFromJSON;
function BankstatementsBalancesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startBalance': !(0, runtime_1.exists)(json, 'startBalance') ? undefined : (0, _1.AmountFromJSON)(json['startBalance']),
        'reductionAmount': !(0, runtime_1.exists)(json, 'reductionAmount') ? undefined : (0, _1.AmountFromJSON)(json['reductionAmount']),
        'increasingAmount': !(0, runtime_1.exists)(json, 'increasingAmount') ? undefined : (0, _1.AmountFromJSON)(json['increasingAmount']),
        'endBalance': !(0, runtime_1.exists)(json, 'endBalance') ? undefined : (0, _1.AmountFromJSON)(json['endBalance']),
    };
}
exports.BankstatementsBalancesFromJSONTyped = BankstatementsBalancesFromJSONTyped;
function BankstatementsBalancesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'startBalance': (0, _1.AmountToJSON)(value.startBalance),
        'reductionAmount': (0, _1.AmountToJSON)(value.reductionAmount),
        'increasingAmount': (0, _1.AmountToJSON)(value.increasingAmount),
        'endBalance': (0, _1.AmountToJSON)(value.endBalance),
    };
}
exports.BankstatementsBalancesToJSON = BankstatementsBalancesToJSON;
//# sourceMappingURL=BankstatementsBalances.js.map